/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Drawer, Toolbar } from '@material-ui/core';

import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

/**
 * region for styles*/
import { layoutMiniSiteStyle } from './style/layoutMiniSiteStyle';

/**
 * region for components*/
import HeaderTitle from '../../../components/common/HeaderTitle';

/**
 * region for containers*/
import WizartSetup from '../../../containers/minisites/WizartSetup';
import MenuMiniSite from '../../../containers/minisites/MenuMiniSite';
import ListMiniSite from '../../../containers/minisites/ListMiniSite';
import UpdateMiniSite from '../../../containers/minisites/UpdateMinisite';

/**
 * region for hepers*/


/**
 * region for constans*/


class LayoutMiniSite extends Component {

    state = {
        showMenu: true
    };

    render() {
        const { classes } = this.props;
        const { showMenu } = this.state;
        return (
            <Router>
                <div className={classes.root}>
                    <AppBar className={clsx(classes.appBar)}
                        position="absolute"
                        color="inherit"
                        elevation={0}>
                        <Toolbar>
                            <HeaderTitle
                                title={"Mini-Site Management"} />
                        </Toolbar>
                    </AppBar>
                    {
                        showMenu && (
                            <Drawer classes={{ paper: clsx(classes.drawerPaper) }}
                                open={true}
                                variant="permanent">
                                <MenuMiniSite />
                            </Drawer>
                        )
                    }
                    <div className={classes.content}>
                        <div className={classes.appBarSpacer} />
                        <Switch>
                            <Route exact={true} path="/LayoutMiniSite/List">
                                <ListMiniSite />
                            </Route>
                            <Route exact={true} path="/LayoutMiniSite/Wizart">
                                <WizartSetup />
                            </Route>
                            <Route exact={true} path="/LayoutMiniSite/Update/:id">
                                <UpdateMiniSite />
                            </Route>
                        </Switch>
                    </div>
                </div>
            </Router >
        );
    }
}
LayoutMiniSite.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(layoutMiniSiteStyle)(LayoutMiniSite);